module.exports = __webpack_public_path__ + "static/media/file.e94406d9.svg";